import { render, staticRenderFns } from "./TacticList.vue?vue&type=template&id=7927cc34"
import script from "./TacticList.vue?vue&type=script&lang=js"
export * from "./TacticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports